"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newestSdkVersion = exports.oldestSdkVersion = exports.defaultSdkVersion = void 0;
exports.defaultSdkVersion = '44.0.0';
// Mostly used for tests
exports.oldestSdkVersion = '41.0.0';
exports.newestSdkVersion = '44.0.0';
//# sourceMappingURL=defaults.js.map